// 스크롤 진입 시 fade-up 클래스 부여 (IntersectionObserver 1개로 전역 관리)
import { useEffect } from 'react'

let io: IntersectionObserver | null = null
const elems = new WeakSet<Element>()

function ensureObserver() {
  if (io || typeof window === 'undefined') return io
  io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add('in')
          io!.unobserve(e.target)
        }
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' },
  )
  return io
}

export function useReveal<T extends HTMLElement = HTMLElement>(ref: React.RefObject<T>) {
  useEffect(() => {
    const node = ref.current
    if (!node) return
    if (elems.has(node)) return
    const obs = ensureObserver()
    if (!obs) return
    elems.add(node)
    node.classList.add('reveal')
    obs.observe(node)
    return () => obs.unobserve(node)
  }, [ref])
}

// JSX에 className="reveal"만 붙여놔도 자동으로 관찰되도록 하는 글로벌 훅
export function useGlobalReveal() {
  useEffect(() => {
    const obs = ensureObserver()
    if (!obs) return
    const nodes = document.querySelectorAll('.reveal:not(.in)')
    nodes.forEach((n) => obs.observe(n))
  }, [])
}
